import React from "react";

import {
    Form,
} from 'antd';
import TextField from '@material-ui/core/TextField';

// import { AntInputField } from "dform-core";
import { RegistorClass } from "../../core/ComponentRegistor";

export class MdInput extends React.Component<any> {
    constructor(props) {
        super(props)
    }
    handleValueChange = (value) => {

    }
    render() {
        const { formLayout } = this.props || "horizontal";
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        const { getFieldDecorator } = this.props.form;

        return (
            <Form.Item {...formItemLayout} label={this.props.label || this.props.name}>
                {getFieldDecorator(this.props.formKey, {
                    rules: [{
                        validator: this.props.validator
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.props.required, message: '必填项!',
                    }],
                })(
                    <TextField disabled={this.props.disabled} fullWidth onChange={this.handleValueChange} />
                )}
            </Form.Item>
        )
    }
}
let scheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
}

RegistorClass({
    componentTag: "MdInput",
    componentObject: MdInput,
    componentName: "Md文本框",
    scheme: scheme,
    defaultProps: {
        span: 12,
        label: "Md文本框",
        required: false
    }
})
// export default AntInput